<template>
  <v-card flat>
    <v-parallax dark :src="lookupAvatarUrl(itemModified)">
      <v-overlay :value="true" :absolute="true" opacity="0.60">
        <v-container>
          <v-row align="center" justify="center">
            <v-col
              cols="12"
              md="12"
              sm="12"
              class="pa-md-2 pa-6"
              align="center"
              justify="center"
            >
              <!-- <v-flex class="d-flex flex-column"> -->
              <div
                class="text-md-h3 text-h4 min-width-800 text-uppercase font-weight-bold"
              >
                {{ itemModified.description }}
              </div>
              <div
                class="text-md-h6 text-subtitle-1 font-weight-light mt-3"
                v-if="itemModified.address !== '-'"
              >
                {{ itemModified.address }}
              </div>
              <v-flex class="d-flex" v-if="false">
                <span
                  class="text-md-h6 text-subtitle-1 font-weight-light"
                  v-if="lookupFSubArea(itemModified.fsubAreaBean).id > 0"
                  >{{
                    lookupFSubArea(itemModified.fsubAreaBean).description
                  }}</span
                >
                <span
                  class="text-md-h6 text-subtitle-1 font-weight-light ml-1"
                  v-if="lookupFSubArea(itemModified.fsubAreaBean).id > 0"
                  >-
                  {{
                    lookupFArea(
                      lookupFSubArea(itemModified.fsubAreaBean).fareaBean
                    ).description
                  }}</span
                >
              </v-flex>

              <div class="mt-4" v-if="$vuetify.breakpoint.mdAndUp"></div>
              <!-- </v-flex> -->
            </v-col>
          </v-row>
        </v-container>
      </v-overlay>
    </v-parallax>
    <ObjectDetailParallax v-if="false"></ObjectDetailParallax>
    <v-flex class="mx-auto d-flex" style="margin-top: -45px">
      <v-row>
        <v-col align="center" cols="12" sm="12" md="8">
          <v-card class="mx-auto mr-md-1 ml-md-16 px-6 py-6">
            <v-row class="px-4 py-4">
              <v-col v-if="false" cols="12" md="4" sm="12" class="pa-3">
                <v-card
                  class="pa-0 ma-0 rounded-lg"
                  height="170px"
                  max-width="300px"
                >
                  <v-hover>
                    <template v-slot:default="{ hover }">
                      <v-img
                        style="width: 100%; height: 100%"
                        class="rounded-lg"
                        :src="lookupAvatarUrl(itemModified)"
                        :lazy-src="lookupAvatarUrlLazy(itemModified)"
                        @click="showImageAvatar(itemModified)"
                        :class="{ 'hover-image': hover }"
                      >
                        <div class="overlay-text text-center py-2" v-if="false">
                          <span class="white--text">Foto-foto</span>
                        </div>
                      </v-img></template
                    >
                  </v-hover>
                </v-card>
              </v-col>
              <v-col cols="12"></v-col>
              <v-card-text class="body-1 pb-0 mb-0">
                <v-textarea
                  v-model="itemModified.notes"
                  flat
                  readonly
                  auto-grow
                  dense
                  solo
                ></v-textarea>
              </v-card-text>
              <v-card-text
                class="py-0 my-0 text-start title font-weight-bold px-7"
              >
                Kebutuhan Akan Investasi
              </v-card-text>
              <v-card-text class="text-start body-1 pt-0 mt-0">
                <v-textarea
                    v-if="itemModified.needs !== ''"
                    v-model="itemModified.needs"
                    flat
                    readonly
                    auto-grow
                    dense
                    solo
                ></v-textarea>
                <div v-if="itemModified.needs === ''" class="px-7">-</div>
              </v-card-text>

              <v-card-text
                v-if="itemsFotoLokasiFiltered.length > 0"
                class="mt-n10 pb-0 mb-0 text-start title font-weight-bold px-7"
              >
                Galeri UMKM
              </v-card-text>
              <v-col
                v-for="(itemFotoLokasi, i) in itemsFotoLokasiFiltered"
                :key="i"
                cols="12"
                md="4"
                sm="12"
                class="pa-3"
              >
                <v-card
                  class="pa-0 ma-0 rounded-lg"
                  height="170px"
                  max-width="300px"
                >
                  <v-hover>
                    <template v-slot:default="{ hover }">
                      <v-img
                        class="rounded-lg"
                        :src="lookupImageUrl(itemFotoLokasi)"
                        :lazy-src="lookupImageUrlLazy(itemFotoLokasi)"
                        style="width: 100%; height: 100%"
                        :class="{ 'hover-image': hover }"
                        @click="showImage(itemFotoLokasi)"
                      >
                        <div class="overlay-text text-center py-2" v-if="false">
                          <span class="white--text">{{
                            itemFotoLokasi.description
                          }}</span>
                        </div>
                      </v-img></template
                    >
                  </v-hover>
                </v-card>
                <!-- {{ itemsFotoLokasi }} -->
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4">
          <v-card class="mx-auto mr-md-16 ml-md-1 ml-3 mr-3 pa-6">
            <v-flex>
              <span class="text-h6 font-weight-bold">Informasi Usaha</span>
              <v-divider class="mt-3 mb-3"></v-divider>
              <div class="body-1">
                <v-icon medium color="orange" class="mr-2"
                  >mdi-map-marker</v-icon
                >
                <!-- {{ itemsFArea }} -->
                <span v-if="lookupFSubArea(itemModified.fsubAreaBean).id > 0">{{
                  lookupFSubArea(itemModified.fsubAreaBean).description
                }}</span>
                <span v-if="lookupFSubArea(itemModified.fsubAreaBean).id > 0"
                  >,
                  {{
                    lookupFArea(
                      lookupFSubArea(itemModified.fsubAreaBean).fareaBean
                    ).description
                  }}</span
                >
              </div>
              <div class="body-1 mt-4" v-if="itemModified.omset !== 0">
                <v-icon medium color="primary" class="mr-2">mdi-cash</v-icon>
                <!-- {{ itemsFArea }} -->
                <span>Omset {{ formatNumberString(itemModified.omset) }}</span>
              </div>
              <div class="subtitle-2 mt-2" v-if="false">
                <v-icon small color="success" class="mr-2">mdi-whatsapp</v-icon>
                <a
                  :href="`https://api.whatsapp.com/send?phone=+62${itemModified.phone}&text=Hi kak, `"
                  target="_blank"
                  >{{ itemModified.phone === "" ? "-" : itemModified.phone }}</a
                >
              </div>
            </v-flex>
            <v-flex> </v-flex>
          </v-card>
          <v-card class="mx-auto mr-md-16 ml-md-1 mt-4 ml-3 mr-3 pa-6">
            <v-flex>
              <span class="text-h6 font-weight-bold">Izin & Surat Usaha</span>
              <v-divider class="mt-3 mb-3"></v-divider>
              <div v-if="ftUmkmPermitsFiltered.length === 0" class="text-center text-subtitle-2 font-weight-light grey--text">Izin & Surat Usaha Belum Dicantumkan</div>
              <div v-if="ftUmkmPermitsFiltered.length > 0" class="body-1 mt-4">
                <div
                  v-for="(ftUmkmPermit, i) in ftUmkmPermitsFiltered"
                  :key="i"
                  class="green--text font-weight-bold"
                >
                  {{ lookupFPermit(ftUmkmPermit.fpermitBean).description }}
                </div>
              </div>
            </v-flex>
            <v-flex> </v-flex>
          </v-card>
        </v-col>

        <v-col cols="12" sm="4" md="4" v-if="false">
          <v-card class="mx-auto ml-10 mr-10">
            <v-card-text>
              <v-tabs color="deep-purple accent-4" left>
                <v-tab>Informasi</v-tab>

                <v-tab-item>
                  <v-container fluid class="body-1">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        v-if="itemModified.lat !== 0"
                      >
                        <v-flex class="d-flex">
                          <v-icon color="blue">mdi-map-marker</v-icon>
                          <v-flex class="ml-10">
                            <div>Latitude, Longitude</div>
                            <div class="caption">
                              {{ itemModified.lat }}, {{ itemModified.lon }}
                            </div>
                          </v-flex>
                        </v-flex>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-flex>

    <v-card height="500px" class="mx-md-16 mx-3 mt-6 pa-6 mb-6" elevation="2">
      <!--      <v-card-title class="font-weight-bold">Peta</v-card-title>-->

      <v-card class="elevation-5 rounded">
        <ObjectDetailMapBasic
          :itemModified="itemModified"
          :itemsFile="itemsFile"
        ></ObjectDetailMapBasic>
      </v-card>
    </v-card>

    <v-card v-if="false" class="ml-16 mr-16 mt-6" elevation="2">
      <v-tabs color="deep-purple accent-4" left>
        <v-tab-item v-for="n in 3" :key="n">
          <v-container fluid>
            <v-row>
              <v-col
                v-for="(item, i) in itemsInfomemoFiltered"
                :key="i"
                cols="12"
                sm="6"
                md="6"
                lg="6"
              >
                <v-hover>
                  <template v-slot:default="{ hover }">
                    <v-img
                      :src="lookupImageUrl(item)"
                      :lazy-src="lookupImageUrlLazy(item)"
                      class="elevation-10 rounded-bl-lg"
                      @click="showImage(item)"
                      :class="{ 'hover-image': hover }"
                    ></v-img>
                  </template>
                </v-hover>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>

    <v-card
      v-if="itemsGalleryFiltered.length > 0"
      class="mx-md-16 mx-3 mb-6"
      elevation="2"
    >
      <v-tabs color="deep-purple accent-4" left>
        <v-tab>Brosur</v-tab>

        <v-tab-item v-for="n in 3" :key="n">
          <v-container fluid class="pa-4">
            <v-row>
              <v-col
                v-for="(itemGallery, i) in itemsGalleryFiltered"
                :key="i"
                cols="12"
                sm="4"
                md="4"
                lg="3"
              >
                <v-hover>
                  <template v-slot:default="{ hover }">
                    <v-img
                      :src="lookupImageUrl(itemGallery)"
                      :lazy-src="lookupImageUrlLazy(itemGallery)"
                      class="elevation-10 rounded-lg"
                      @click="showImage(itemGallery)"
                      :class="{ 'hover-image': hover }"
                    ></v-img>
                  </template>
                </v-hover>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>

    <v-card v-if="false" class="ml-16 mr-16 mt-6" elevation="2">
      <v-tabs color="deep-purple accent-4" left>
        <v-tab>Video</v-tab>

        <v-tab-item v-for="n in 3" :key="n">
          <v-container fluid>
            <v-row>
              <v-col
                v-for="(item, i) in itemsVideoFiltered"
                :key="i"
                cols="12"
                sm="6"
                md="6"
                lg="4"
              >
                <v-hover>
                  <template v-slot:default="{ hover }">
                    <Media
                      :kind="'video'"
                      :isMuted="false"
                      :src="urlMp4File(item)"
                      :controls="true"
                      :autoplay="false"
                      :ref="'fish'"
                      :style="{ width: '450px' }"
                      @pause="handle()"
                      class="rounded-lg elevation-10"
                      :class="{ 'hover-image': hover }"
                    >
                    </Media>
                  </template>
                </v-hover>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>

    <AppFooter></AppFooter>

    <FUmkmDetilShowImageDialog ref="refShowImage"></FUmkmDetilShowImageDialog>
    <FUmkmDetilShowImageAvatarDialog
      ref="refShowImageAvatar"
    ></FUmkmDetilShowImageAvatarDialog>
  </v-card>
</template>

<script>
import AppFooter from "@/components/AppFooter.vue";
import FileService from "@/services/apiservices-umkm/file-service";
import FUmkmService from "@/services/apiservices-umkm/f-umkm-service";
import FPermitService from "@/services/apiservices-umkm/f-permit-service";
import FUmkmTypeService from "@/services/apiservices-umkm/f-umkm-type-service";
import FSectorTypeService from "@/services/apiservices/f-sector-type-service";
import FKomoditiTypeService from "@/services/apiservices/f-komoditi-type-service";
import FInfrastructureTypeService from "@/services/apiservices/f-infrastructure-type-service";
import FtUmkmPermitService from "@/services/apiservices-umkm/ft-umkm-permit-service";
import FUmkm from "@/models/umkm/f-umkm";
import FUmkmDetilShowImageDialog from "@/components/utils-umkm/ShowImageDialog";
import FUmkmDetilShowImageAvatarDialog from "@/components/utils-umkm/ShowImageAvatarDialog";
import ObjectDetailParallax from "@/components/public-umkm-bermitra-detail/ObjectDetailParallax";
import FSubAreaService from "@/services/apiservices/f-sub-area-service";
import FAreaService from "@/services/apiservices/f-area-service";
import ObjectDetailMapBasic from "@/components/public-umkm-bermitra-detail/ObjectDetailMapBasic.vue";
import FUmkmFileService from "@/services/apiservices-umkm/f-umkm-file-service";

export default {
  name: "ObjectDetail",
  components: {
    ObjectDetailMapBasic,
    ObjectDetailParallax,
    FUmkmDetilShowImageDialog,
    FUmkmDetilShowImageAvatarDialog,
    AppFooter,
  },
  data: () => ({
    isMedium: false,
    ftUmkmPermitsFiltered: [],
    itemsFUmkmType: [],
    itemsFPermit: [],
    itemModified: new FUmkm(),
    itemsFile: [],

    itemsFDivision: [],
  }),
  watch: {},
  computed: {
    itemsFotoLokasiFiltered() {
      return this.itemsFile.filter(
        (item) => item.description !== "Brosur" && item.fileType === "IMAGE"
      );
    },
    itemsGalleryFiltered() {
      return this.itemsFile.filter(
        (item) => item.description === "Brosur" && item.fileType === "IMAGE"
      );
    },

    itemsFSubArea() {
      return this.$store.state.umkm.itemsFSubArea;
    },
    itemsFArea() {
      return this.$store.state.umkm.itemsFArea;
    },
  },
  methods: {
    fetchParent() {
      FUmkmTypeService.getAllFUmkmTypePublic().then(
        (response) => {
          this.itemsFUmkmType = response.data;
        },
        (error) => {
          console.log(error.response);
        }
      );
      FPermitService.getAllFPermitPublic().then(
        (response) => {
          this.itemsFPermit = response.data;
        },
        (error) => {
          console.log(error.response);
        }
      );
      FSectorTypeService.getAllFSectorTypePublic().then(
        (response) => {
          this.$store.dispatch("potensi/updateItemsFSectorType", response.data);
        },
        (error) => {
          console.log(error.response);
        }
      );
      FKomoditiTypeService.getAllFKomoditiTypePublic().then(
        (response) => {
          this.$store.dispatch(
            "potensi/updateItemsFKomoditiType",
            response.data
          );
        },
        (error) => {
          console.log(error.response);
        }
      );
      FInfrastructureTypeService.getAllFInfrastructureTypePublic().then(
        (response) => {
          this.$store.dispatch(
            "potensi/updateItemsFInfrastructureType",
            response.data
          );
        },
        (error) => {
          console.log(error.response);
        }
      );
      FSubAreaService.getAllFSubAreaPublic().then(
        (response) => {
          this.$store.dispatch(
            "umkm/updateItemsFSubArea",
            response.data
          );
        },
        (error) => {
          console.log(error.response);
        }
      );
      FAreaService.getAllFAreaPublic().then(
        (response) => {
          this.$store.dispatch(
            "umkm/updateItemsFArea",
            response.data
          );
        },
        (error) => {
          console.log(error.response);
        }
      );
    },
    lookupFUmkmType(fumkmTypeBean) {
      const str = this.itemsFUmkmType.filter((x) => x.id === fumkmTypeBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupFPermit(fpermitBean) {
      const str = this.itemsFPermit.filter((x) => x.id === fpermitBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupFSubArea(fsubAreaBean) {
      const str = this.itemsFSubArea.filter((x) => x.id === fsubAreaBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupFArea(fareaBean) {
      const str = this.itemsFArea.filter((x) => x.id === fareaBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupAvatarUrl(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_high(item.avatarImage);
      }
    },
    lookupAvatarUrlLazy(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },

    lookupImageUrl(item) {
      if (item.fileName === undefined) {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_medium(item.fileName);
      }
    },
    lookupImageUrlLazy(item) {
      return FileService.image_url_verylow(item.fileName);
    },

    formatNumberString(value) {
      let valueStr = "";
      if (value / 1000000000000 > 1) {
        valueStr = `${parseFloat(value / 1000000000000).toFixed(2)} Triliun`;
      } else if (value / 1000000000 > 1) {
        valueStr = `${parseFloat(value / 1000000000).toFixed(2)} Miliar`;
      } else if (value / 1000000 > 1) {
        valueStr = `${parseFloat(value / 1000000).toFixed(2)} Juta`;
      } else if (value / 1000 > 1) {
        valueStr = `${parseFloat(value / 1000).toFixed(2)} Ribu`;
      } else {
        valueStr = value.toString();
      }
      return valueStr;
    },

    retrieveFiles() {
      FAreaService.getAllFAreaPublic().then(
        (response) => {
          this.$store.dispatch("potensi/updateItemsFArea", response.data);
        });
      FSubAreaService.getAllFSubAreaPublic().then(
        (response) => {
          this.$store.dispatch("potensi/updateItemsFSubArea", response.data);
        });
      FUmkmFileService.getAllFUmkmFileByParentPublic(this.itemModified.id).then(
        (response) => {
          this.itemsFile = response.data;
        },
        (error) => {
          console.log(error.response);
        }
      );
      FtUmkmPermitService.getAllFtUmkmPermitByParentPublic(
        this.itemModified.id
      ).then(
        (response) => {
          this.ftUmkmPermitsFiltered = response.data;
        },
        (error) => {
          console.log(error.response);
        }
      );
    },

    urlMp4File(item) {
      return FileService.fileStreamMp4File(item.fileName);
    },
    handle() {
      // console.log("Video paused!, playing in 2 sec...");

      setTimeout(() => {
        this.$refs.fish.play();
      }, 2000);
    },

    showImage(value) {
      this.$refs.refShowImage.showDialog(value);
    },
    showImageAvatar(value) {
      this.$refs.refShowImageAvatar.showDialog(value);
    },
  },

  mounted() {
    const id = this.$route.params.id;

    this.fetchParent();

    FUmkmService.getFUmkmByIdPublic(id).then(
      (response) => {
        this.itemDefault = Object.assign({}, response.data);
        this.itemModified = response.data;
        // this.center = [-7.95956, 112.63529]
        // this.markerLatLng = [-7.95956, 112.63529]
        // console.log(this.markerLatLng);

        this.retrieveFiles();
      },
      (error) => {
        console.log(error);
      }
    );
  },
  created() {
    this.isMobile = this.$vuetify.breakpoint.smAndDown; // Check if it's a mobile screen
    this.$vuetify.breakpoint.mdUp = () => {
      this.isMobile = false;
    };
    this.$vuetify.breakpoint.smAndDown = () => {
      this.isMobile = true;
    };
  },
};
</script>
  
<style scoped>
.overlay-text {
  background-color: black;
  opacity: 0.7;
  position: absolute;
  width: 100%;
  z-index: 3;
  bottom: 0;
}
.fit-cover {
  background-size: cover;
}
.floating-button {
  z-index: 99;
  position: fixed;
  bottom: 20px; /* Adjust the distance from the bottom as needed */
  right: 20px; /* Adjust the distance from the right as needed */
}
.custom-divider {
  height: 40px;
}
.min-width-800 {
  min-width: 90%;
}

.hover-image {
  opacity: 0.6;
  cursor: pointer;
}
</style>
  